import axios, { AxiosResponse } from "axios";
import store from "store";

const baseURL = process.env.REACT_APP_API_DEPARTMENT;

const axiosManagerPageClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosManagerPageClient.interceptors.request.use(
  function (config: any) {
    //@ts-ignore
    config.headers.Authorization = `Bearer ${
      store?.getState().departmentState.access_token
    }`;

    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

axiosManagerPageClient.interceptors.response.use(
  function (response: AxiosResponse) {
    return response.data;
  },

  function (error) {
    return Promise.reject(error);
  }
);

export { axiosManagerPageClient };
